import Styles from './QuizViewCard.module.scss';
import React from 'react';
// Module imports.
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

// Components import.
import { useTranslation } from 'components/lib';

const QuizViewCard = (props) => {

	const { t } = useTranslation();
	const { data } = props;

	return (
		<div id='parentContainer' className={Styles.parentContainer}
			onClick={data.isDisabled ? null : () => props.onStartClick(data.id)}
			style={{
				cursor: data.isDisabled ? "default" : "pointer",
				pointerEvents: data.isDisabled ? "none" : "all",
				opacity: data.isDisabled ? "0.7" : "1",
			}}
		>
			<div
				id='informationContainer'
				className={Styles.informationContainer}
				style={{
					width: data.description ? "85%" : "50%",
				}}
			>
				{/* Image Part */}
				<div id='imageContainer' className={Styles.imageContainer}>
					<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data.icon}`} className={Styles.courseImage} alt="courseImg" />
				</div>
				{/* Content Part */}
				<div
					className={Styles.contentContainer}
					style={{
						width: data.description ? "89%" : "50%",
					}}
				>
					<p
						className={Styles.headerText}
						style={{
							paddingBottom: data.description ? "0" : "16px",
						}}
					>
						{data.name}
					</p>
					<div id='userStatsContainer' className={Styles.userStatsContainer}>
						<p
							style={{
								fontSize: data.description && "0.7em",
								fontWeight: data.description ? "500" : "100"
							}}
						>
							{t('Components.QuizViewCard.attempts')} {data.attempts ? data.attempts : 0}
						</p>
						{(data.attempts >= 1 && data.description) &&
							<p
								style={{
									fontSize: data.description && "0.7em",
									fontWeight: data.description ? "500" : "100",
									marginLeft: "0.2em"
								}}
							>
								{t('Components.QuizViewCard.score')} {data.highest_score ? data.highest_score : 0}/100
							</p>
						}
						{data?.nextAttemptDate &&
							<p
								style={{
									fontSize: data.description && "0.7em",
									fontWeight: data.description ? "500" : "100",
									marginLeft: "0.2em"
								}}
							>
								{t('Components.QuizViewCard.next')} {data?.nextAttemptDate}
							</p>
						}
					</div>
					{data?.description &&
						<p className={Styles.descriptionText}>{data.description}</p>
					}
				</div>
			</div>
			{/*Button  Part */}
			<div id='buttonContainer' className={Styles.buttonContainer}>
				<button
					className={Styles.startButton}

					disabled={data.isDisabled}
				>
					{data.isDisabled && (
						<LockIcon sx={{ mr: 1 }} />
					)}
					{data.isCompleted && !data.isDisabled && (
						<CheckCircleIcon sx={{ mr: 1 }} />
					)}
					{!data.isCompleted && !data.isDisabled && (
						<PlayCircleFilledIcon sx={{ mr: 1 }} />
					)}
					{t(`Components.QuizViewCard.buttonText.${props.button_text}`)}
				</button>

			</div>
		</div>
	);
};

export default QuizViewCard;
